import { Link } from 'react-router-dom';

export default function AISearchPage() {
  return (
    <div style={{ background: 'white', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto 40px' }}>
          <div style={{ display: 'inline-flex', background: '#E8EAF6', color: '#2962FF', fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 99, marginBottom: 16 }}>AI SEARCH OPTIMIZATION</div>
          <h1 style={{ fontSize: 48, fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 16 }}>AI Search Optimization<br/><span style={{ color: '#2962FF' }}>Get Cited by ChatGPT & Perplexity</span></h1>
          <p style={{ fontSize: 18, color: '#6B7280', lineHeight: 1.5, marginBottom: 24 }}>A growing share of searches now happen inside ChatGPT, Perplexity, and Google's AI Overviews. Here's how to structure your content so these systems can find and cite it.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/blog/ai-search-optimization-guide" className="btn btn-lg" style={{ background: '#2962FF', color: 'white', height: 48, padding: '0 24px', fontSize: 15 }}>Read the Full Guide →</Link>
            <Link to="/keywords/magic" className="btn btn-lg btn-white" style={{ height: 48 }}>Find Keywords</Link>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, marginBottom: 40 }}>
          {[
            { icon: '🤖', title: 'Question-Based Content', desc: 'Structure headings as the actual questions people ask' },
            { icon: '🔍', title: 'Direct Answers', desc: 'State the answer clearly in the first sentence, not buried in paragraph five' },
            { icon: '✨', title: 'FAQ Schema', desc: 'Markup that gives AI crawlers a clean, structured answer to pull from' },
            { icon: '📊', title: 'Keyword Research', desc: 'Find the question-style, conversational keywords worth targeting' },
            { icon: '📝', title: 'Topical Depth', desc: 'One thorough page beats five thin ones on the same topic' },
            { icon: '🔗', title: 'Trust Signals', desc: 'Citations and mentions from established sources still matter' },
          ].map(f => (
            <div key={f.title} className="card" style={{ margin: 0 }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>{f.icon}</div>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{f.title}</div>
              <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.5 }}>{f.desc}</div>
            </div>
          ))}
        </div>

        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 16, textAlign: 'center' }}>What Is AI Search, Really?</h2>
          <div style={{ background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 12, padding: 24, fontSize: 14, lineHeight: 1.7, color: '#37474F' }}>
            <p><strong>AI search</strong> means getting your answer directly from a conversational AI model — ChatGPT, Perplexity, Claude, or Google's AI Overviews — instead of clicking through a list of links.</p>
            <p style={{ marginTop: 12 }}><strong>Why it matters:</strong> if your content isn't structured to be easily quoted, you can lose visibility for the exact queries you used to rank well for in traditional search — even while your Google ranking stays the same.</p>
            <p style={{ marginTop: 12 }}><strong>Where to start:</strong> question-based headings, a direct answer up front, FAQ schema, and genuine topical depth. See the full guide for the details.</p>
          </div>

          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <Link to="/blog" className="btn btn-black">Read the Blog →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
